var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-large",
    clipPath: "url(#clip0_8429_119991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 11.25C13.1066 11.25 15.625 8.73164 15.625 5.625C15.625 2.51836 13.1066 0 10 0C6.89375 0 4.375 2.51836 4.375 5.625C4.375 8.73164 6.89453 11.25 10 11.25ZM10 1.25C12.4125 1.25 14.375 3.2125 14.375 5.625C14.375 8.03906 12.4141 10 10 10C7.58594 10 5.625 8.03906 5.625 5.625C5.625 3.2125 7.58594 1.25 10 1.25ZM13.7148 12.5H6.25C2.79844 12.5 0 15.298 0 18.75C0 19.4402 0.559766 20 1.21484 20H18.75C19.4402 20 19.9648 19.4402 19.9648 18.75C20 15.2969 17.2031 12.5 13.7148 12.5ZM1.25 18.75C1.25 15.993 3.49297 13.75 6.25 13.75H13.7148C16.5078 13.75 18.75 15.9922 18.75 18.75H1.25Z",
    fill: "#383A3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8429_119991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.47773d579eddc1314d68cb43f97fa215.svg";
export { ForwardRef as ReactComponent };